export default {
  home: '/home/home',
  drawer: '/home/drawer',
};
